import commonMapping from "@/mapping/common";

const enable_options_list = [
  {
    config: "1",
    value: "1",
    label: "r_enable",
    id: "enable",
  },
  {
    config: "0",
    value: "0",
    label: "r_disable",
    id: "disable",
  },
];

export const logs = {
  allow_sites_enable: commonMapping.intToBoolean,
  block_sites_service_enable: commonMapping.intToBoolean,
  conn_web_interface_enable: commonMapping.intToBoolean,
  router_operation_enable: commonMapping.intToBoolean,
  dos_attacks_port_scan_enable: commonMapping.intToBoolean,
  port_forwarding_triggering_enable: commonMapping.intToBoolean,
  wireless_access_enable: commonMapping.intToBoolean,
  wireless_signal_sched_enable: commonMapping.intToBoolean,
  vpn_services_enable: commonMapping.intToBoolean,
  insight_enable: commonMapping.intToBoolean,
  remote_enable: enable_options_list,
};

export default logs;
